module.exports = "dist/images/components-design-separator-control-slant-1.1a7bbee.png";